// import React from "react";
// import { useNavigate } from "react-router-dom";
// import BgImg from "../../assets/portfolio/bg2.png";
// import Case1 from "../../assets/portfolio/case-1.png";
// import Case2 from "../../assets/portfolio/case-2.png";
// import Case3 from "../../assets/portfolio/case-3.png";
// import Case4 from "../../assets/portfolio/case-4.png";

// // Utility to convert title to slug
// const toSlug = (text) =>
//   text
//     .toLowerCase()
//     .replace(/[^\w ]+/g, "")
//     .replace(/ +/g, "-");

// const Casestudy = () => {
//   const navigate = useNavigate();

//   const caseStudies = [
//     { id: 1, imgSrc: Case1, title: "60% increase in organic traffic." },
//     {
//       id: 2,
//       imgSrc: Case2,
//       title: "243% increase in keywords driving traffic.",
//     },
//     {
//       id: 3,
//       imgSrc: Case3,
//       title: "Digital Marketing strategy to increase traffic.",
//     },
//     { id: 4, imgSrc: Case4, title: "568.67% increase in website traffic." },
//   ];

//   const handleClick = (title) => {
//     const slug = toSlug(title);
//     navigate(`/case-studies/${slug}`);
//   };

//   return (
//     <div>
//       <div
//         className="py-5 px-5 relative"
//         data-aos="fade-up"
//         style={{
//           backgroundImage: `url(${BgImg})`,
//           backgroundRepeat: "repeat",
//           backgroundSize: "auto",
//           backgroundPosition: "center",
//           backgroundAttachment: "fixed",
//           minHeight: "60vh",
//         }}
//       >
//         <div className="text-center py-10 px-4">
//           <h2 className="text-2xl md:text-4xl font-extrabold">
//             <span className="text-black">OUR CASE </span>
//             <span className="text-sky-500">STUDIES</span>
//           </h2>

//           <div className="relative w-fit mx-auto mt-2">
//             <div className="h-[1px] bg-gray-300 md:w-[300px] w-[150px] mx-auto"></div>
//             <div className="absolute left-1/2 -translate-x-1/2 -top-[1px] flex gap-2">
//               <div className="w-8 h-[2px] bg-sky-500"></div>
//               <div className="w-8 h-[2px] bg-sky-500"></div>
//             </div>
//           </div>

//           <p className="text-gray-500 text-base mt-4">
//             What You Get Using Our Company's
//           </p>
//         </div>

//         <div className="px-2">
//           <div className="grid grid-cols-1 md:grid-cols-4 md:gap-3">
//             {caseStudies.map((study) => (
//               <div
//                 className="col-span-1"
//                 key={study.id}
//                 onClick={() => handleClick(study.title)}
//               >
// {/* <div className="relative overflow-hidden cursor-pointer">
//   <img
//     src={study.imgSrc}
//     alt={study.title}
//     className="w-full h-auto"
//   />
//   <div
//     className="absolute top-0 left-0 w-full h-full flex items-center justify-center text-white opacity-0 hover:opacity-100 transition-opacity duration-300"
//     style={{ backgroundColor: "rgba(0, 0, 0, 0.7)" }}
//   >
//     <p className="uppercase font-bold text-center px-2">
//       {study.title}
//     </p>
//   </div>
// </div> */}
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Casestudy;

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BgImg from "../../assets/portfolio/bg2.png";
import BASE_URL from "../../config/config";
const IMAGE_BASE_URL = `${BASE_URL}/employees/view/`;
const API_URL = `${BASE_URL}/case-studies/list`;

// Utility to convert title to slug
const toSlug = (text) =>
  text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "") // keep letters, numbers, space, hyphen
    .replace(/\s+/g, "-"); // replace spaces with dashes
// replace spaces with dashes

const Casestudy = () => {
  const navigate = useNavigate();
  const [caseStudies, setCaseStudies] = useState([]);

  useEffect(() => {
    axios
      .get(API_URL)
      .then((res) => {
        if (res.data?.success && Array.isArray(res.data?.data)) {
          setCaseStudies(res.data.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching case studies:", err);
      });
  }, []);

  const handleClick = (title) => {
    const slug = toSlug(title);
    navigate(`/case-studies/${slug}`, { state: { title } });
  };

  return (
    <div>
      <div
        className="py-5 px-5 relative"
        data-aos="fade-up"
        style={{
          backgroundImage: `url(${BgImg})`,
          backgroundRepeat: "repeat",
          backgroundSize: "auto",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          minHeight: "60vh",
        }}
      >
        <div className="text-center py-10 px-4">
          <h2 className="text-2xl md:text-4xl font-extrabold">
            <span className="text-black">OUR CASE </span>
            <span className="text-sky-500">STUDIES</span>
          </h2>

          <div className="relative w-fit mx-auto mt-2">
            <div className="h-[1px] bg-gray-300 md:w-[300px] w-[150px] mx-auto"></div>
            <div className="absolute left-1/2 -translate-x-1/2 -top-[1px] flex gap-2">
              <div className="w-8 h-[2px] bg-sky-500"></div>
              <div className="w-8 h-[2px] bg-sky-500"></div>
            </div>
          </div>

          <p className="text-gray-500 text-base mt-4">
            What You Get Using Our Company's
          </p>
        </div>
        {/* home page rendering */}
        <div className="px-2">
          <div className="grid grid-cols-1 md:grid-cols-4 md:gap-3">
            {caseStudies.map((study) => (
              <div
                className="col-span-1"
                key={study.id}
                onClick={() => handleClick(study.title)}
              >
                <div className="relative overflow-hidden cursor-pointer">
                  <img
                    src={`${IMAGE_BASE_URL}${study.imagePreview}`}
                    alt={study.title}
                    className="w-full h-full"
                  />
                  <div
                    className="absolute top-0 left-0 w-full h-full flex items-center justify-center text-white opacity-0 hover:opacity-100 transition-opacity duration-300"
                    style={{ backgroundColor: "rgba(0, 0, 0, 0.7)" }}
                  >
                    <div className="text-center px-2">
                      <p className="uppercase hover:text-main1 font-bold">
                        {study.title}
                      </p>
                      <span className="text-sm hover:text-main1 mt-1 block">
                        see full case study
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Casestudy;
